import { getElementSize } from '../utils/sizes';
import { ITEMS_BY_BREAKPOINTS, templates } from './customer/default/poster.constants';

export * from './customer/default/poster.constants';

const RATIO = 9 / 16;

const { sizes, imageOptions } = [templates.PosterS, templates.PosterM, templates.PosterL].reduce(
  (acc, template) => {
    const { sizes: templateSizes, imageOptions: templateImageOptions } = getElementSize(
      ITEMS_BY_BREAKPOINTS[template],
      RATIO,
      template,
    );
    acc.sizes[template] = templateSizes[template];
    acc.imageOptions[template] = templateImageOptions[template];

    return acc;
  },
  { sizes: {}, imageOptions: {} },
);

export { sizes, imageOptions };
